// Small shared constants for the marketing/auth/legal surfaces (landing,
// Signin, RequestAccess, the /privacy and /terms shell). These pages
// intentionally set their own font stack and a lighter hairline border than
// the admin/chat surfaces use — centralized here instead of copy-pasted
// per file so the handful of pages that share this look can't drift.
export const FONT_STACK =
  '"Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif';
export const BORDER_COLOR = "#e4e4e7";
